import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { StyledGallerySlideProps } from './Gallery.types';
import LoadingSpinnerSVG from 'public/assets/spinner.svg';

export const Slide = styled('li')<StyledGallerySlideProps>(
    ({
        allowCropping,
        maxImageDimensions,
        isScaledAlongHorizontalAxis,
        isImageLoaded = false,
        isZoomed = false
    }) => {
        const isScaledAlongVerticalAxis = !isScaledAlongHorizontalAxis;

        return css`
            position: relative;
            display: block;
            width: 100%;
            height: 100%;
            flex-shrink: 0;
            overflow: hidden;
            cursor: pointer;
            touch-action: ${isZoomed ? 'none' : 'pan-y'};

            ${!isImageLoaded &&
            `
            background: url(${LoadingSpinnerSVG}) 50% 50% no-repeat;
            background-size: 48px 48px;
            `}

            img {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                width: ${isScaledAlongHorizontalAxis
                    ? '100%'
                    : allowCropping && !isImageLoaded
                    ? '100%'
                    : 'auto'};
                height: ${isScaledAlongVerticalAxis
                    ? '100%'
                    : allowCropping && !isImageLoaded
                    ? '100%'
                    : 'auto'};
                transform: translate(-50%, -50%);
                object-fit: cover;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

                /* Don't allow the image to be stretched larger than its own dimensions... */
                max-width: ${maxImageDimensions[0]}px;
                max-height: ${maxImageDimensions[1]}px;

                /* ... unless we specifically allow it so stretch and/or overflow the viewport */
                ${allowCropping &&
                `
                    max-width: none;
                    max-height: none;
                `};
            }
        `;
    }
);

export const SlideImageWrapper = styled('div')(css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transform-origin: 0 0;
`);
